//Import configs
import routes from 'configs/routes'; 

//Import components
import { React, useState, useEffect, useRef, forwardRef } from 'react';
import { Switch, useLocation, useHistory } from 'react-router-dom';
import ReactGA from "react-ga4";
import { AnimatePresence } from 'framer-motion';
import useScrollMemory from 'functions/useScrollMemory';

import {PageLoader} from 'components/Loader';
import CustomRoute from 'components/Navigation/CustomRoute';
import Navbar from 'components/Navigation/Navbar';
import Footer from 'components/Navigation/Footer';
import Index from 'pages/Index';
import Apartments from 'pages/Apartments';
import Apartment from 'pages/Apartment';
import PaymentInformations from 'pages/PaymentInformations';
import Documents from 'pages/Documents';
/* import Contact from 'pages/Contact'; */
import GalleryC from 'pages/Gallery';
import {default as BlogListingsPage} from 'pages/BlogListings';
import {default as BlogSinglePage} from 'pages/BlogSingle';

import Login from 'pages/Login';
import Dashboard from 'pages/Dashboard';
import PageNotFound from 'pages/PageNotFound';

import CookieBar from 'components/Cookie/CookieBar';
import getCookie from 'components/Cookie/getCookie';



import clg from 'functions/log';
import auth from 'functions/auth';
import settings from 'configs/settings';


//Import functions

/* ================================================================== */



//Oldalváltáskor
function usePageViews() {

  let location = useLocation();
  let history = useHistory();

  //Google Analytics
  const analyticsCookieAccepted = getCookie("cookie_settings", "analytics");

  if( analyticsCookieAccepted ) {
    ReactGA.initialize(settings.google_analytics.id);
    //ReactGA.initialize(settings.google_analytics, /* {debug : settings.debug} */);
    //ReactGA.pageview(location.pathname);
  } 

  useEffect(() => {
    //Kijelentkeztetés miatt el kell tudni érni a history objectet.
    if( auth.isAuthenticated() ) {
      auth.setHistory( history );
    }
  }, [location]);
}

const scrollData = {};

const App = () => {




  usePageViews();
  useScrollMemory(scrollData);

  const location = useLocation();
  const footerRef = useRef(null);
  const introductionRef = useRef(null);
  const newsletterRef = useRef(null);



  //index.html-ben lévő loader eltüntetése az első render után.
  useEffect(() => {
    const indexPageLoader = document.getElementById("index-page-loader");
    if( indexPageLoader ) indexPageLoader.remove();
  },[])

  useEffect(()=>{


    const hash = location?.hash || null;

    switch (hash) {
      case routes.contact.replace("/", ""):

        if( footerRef.current ) {
          footerRef.current.scrollIntoView();
        }
        break;

    }

  },[location])

  return (
      <>

        <Navbar footerRef={ footerRef } introductionRef={ introductionRef } newsletterRef={newsletterRef} /> 
        <AnimatePresence exitBeforeEnter>

          <Switch location={location} key={location.pathname}>

            <CustomRoute path="/" exact component={ () => { return <Index footerRef={ footerRef } forwardRef={ introductionRef } newsletterRef={newsletterRef}/>} } componentName="Index" />

            {/*<CustomRoute path={ routes.index } component={ () => { return <Index footerRef={ footerRef } forwardRef={ introductionRef } newsletterRef={newsletterRef}/>} } componentName="Index" />*/}

            <CustomRoute path={ routes.apartments } exact component={ Apartments } componentName="Apartments" />

            <CustomRoute path={ routes.apartment } component={ Apartment } componentName="Apartment" />

            <CustomRoute path={ routes.paymentInformations } component={ PaymentInformations } componentName="PaymentInformations" />

            <CustomRoute path={ routes.documents } component={ Documents } componentName="Documents" />

            <CustomRoute path={ routes.blogListings } exact component={ BlogListingsPage } componentName="BlogListings" />

            <CustomRoute path={ routes.blogSingle } component={ BlogSinglePage } componentName="BlogSingle" />

            <CustomRoute path={ routes.gallery } component={ GalleryC } componentName="Gallery" />

            {/* <CustomRoute path={ routes.contact } component={ Contact } componentName="Contact" /> */}

            <CustomRoute path={ routes.admin } exact component={ Login } componentName="Login overlay" />

            <CustomRoute protected={true} path={ routes.dashboard } component={ Dashboard } componentName="Dashboard" />

            <CustomRoute component={ PageNotFound } componentName="PageNotFound" />

          </Switch>

        </AnimatePresence>

        {/*<span>{location.pathname}</span>*/}
        {/* <span>{`${location.pathname !== "/"}`}</span> */}

        {
          !location.pathname.includes( routes.admin ) && (
            <Footer forwardRef={ footerRef } /> 
          )
        }

        
        
      </>
  );
} 

export default App;
